// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-right-message-box-container{
    right: 2vw;
    bottom: 2vh;
    color: white;
    border-radius: 5px;
    position: absolute;
    background-color: rgb(0, 168, 0);
}
.bottom-right-message-box-container p{
    margin: 0px;
    padding: 8px 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/UniversalComponentsStyles/BottomRightMessageBox.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".bottom-right-message-box-container{\r\n    right: 2vw;\r\n    bottom: 2vh;\r\n    color: white;\r\n    border-radius: 5px;\r\n    position: absolute;\r\n    background-color: rgb(0, 168, 0);\r\n}\r\n.bottom-right-message-box-container p{\r\n    margin: 0px;\r\n    padding: 8px 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
